import React from 'react'
import { getUriFromDocument } from '@utils/routing';
import { Link } from 'gatsby';
import Image from '../image';

const BlogItem = ({item}) => {
  const { title, mainImage } = item;
  const blogUrl = getUriFromDocument(item);

  return (
    <div className="flex flex-col gap-y-5 mx-[5px] lg:mx-2.5">
      <div className="relative aspect-[4/3] group">
        <Link
          to={blogUrl}
          // tabIndex={-1}
          aria-label={"Blog Item: " + title}
          title={"Blog Item: " + title}
        >
          <Image
            image={mainImage}
            width={430}
            height={350}
            className="rounded-xl w-full h-full"
          />
        </Link>
      </div>
      <Link
        to={blogUrl}
        // tabIndex={-1}
        aria-label={"Blog Item: " + title}
        title={"Blog Item: " + title}
      >
        <p className="font-medium">{title}</p>
      </Link>
    </div>
  )
}

export default BlogItem